module.exports = __webpack_public_path__ + "img/stack-overflow-dreaded.43892ca2.png";